/**
 * frontend/src/utils/constants.js
 * Shared UI constants - status/priority/severity colour maps.
 * Extracted from api.js where they did not belong (these are not API calls).
 * Import from here in components; api.js re-exports them for backwards
 * compatibility with any existing imports.
 *
 * Usage:
 *   import { STATUS_COLORS, PRIORITY_COLORS, SEVERITY_COLORS } from '../utils/constants';
 */

// Maps entity status values → Tailwind badge class strings.
// Consistent across Projects, Tasks, Bugs, Change Requests.
export const STATUS_COLORS = {
  // Project statuses
  'Not Started':       'border border-slate-400  text-slate-600  dark:text-slate-400',
  'Active':            'border border-emerald-500 text-emerald-600 dark:text-emerald-400',
  'On Hold':           'border border-amber-500  text-amber-600  dark:text-amber-400',
  'Completed':         'border border-blue-500   text-blue-600   dark:text-blue-400',
  // Task & Activity statuses
  'Pending':           'border border-slate-400  text-slate-500  dark:text-slate-400',
  'In Progress':       'border border-brand-500  text-brand-600  dark:text-brand-400',
  'Blocked':           'border border-red-500    text-red-600    dark:text-red-400',
  'Cancelled':         'border border-slate-400  text-slate-400  dark:text-slate-500',
  // Bug statuses
  'Open':              'border border-orange-500 text-orange-600 dark:text-orange-400',
  'Fixed':             'border border-emerald-500 text-emerald-600 dark:text-emerald-400',
  'Verified':          'border border-blue-500   text-blue-600   dark:text-blue-400',
  'Closed':            'border border-slate-400  text-slate-500  dark:text-slate-400',
  // Change Request statuses
  'Under Review':      'border border-purple-500 text-purple-600 dark:text-purple-400',
  'Approved':          'border border-emerald-500 text-emerald-600 dark:text-emerald-400',
  'Rejected':          'border border-red-500    text-red-600    dark:text-red-400',
  'Implemented':       'border border-blue-500   text-blue-600   dark:text-blue-400',
  // Milestone statuses
  'Skipped':           'border border-slate-300  text-slate-400  dark:text-slate-500',
  // Workplan statuses
  'Planned':           'border border-brand-400  text-brand-500  dark:text-brand-400',
  'Done':              'border border-emerald-500 text-emerald-600 dark:text-emerald-400',
  // Delegation statuses
  'pending_acceptance':'border border-amber-500  text-amber-600  dark:text-amber-400',
  'accepted':          'border border-emerald-500 text-emerald-600 dark:text-emerald-400',
  'declined':          'border border-red-500    text-red-600    dark:text-red-400',
  'revoked':           'border border-slate-400  text-slate-500  dark:text-slate-400',
};

export const PRIORITY_COLORS = {
  'Low':      'border border-slate-400  text-slate-500  dark:text-slate-400',
  'Medium':   'border border-amber-500  text-amber-600  dark:text-amber-400',
  'High':     'border border-orange-500 text-orange-600 dark:text-orange-400',
  'Critical': 'border border-red-500    text-red-600    dark:text-red-400',
};

export const SEVERITY_COLORS = {
  'Minor':    'border border-slate-400  text-slate-500  dark:text-slate-400',
  'Major':    'border border-orange-500 text-orange-600 dark:text-orange-400',
  'Critical': 'border border-red-500    text-red-600    dark:text-red-400',
};

// Q-Lana brand palette - centralised here so a single edit propagates everywhere.
// Mirrors the CSS variables in index.css; used in Recharts (which needs hex, not CSS vars).
export const BRAND_COLORS = {
  sapphire: '#2E539F', // primary
  java:     '#5CC3BC', // secondary accent
  sunglow:  '#FFC849', // highlights / warnings only
};
